// Copyright © 2015-2020 TrampleZone LLC All Rights Reserved

// Avatar Module

// Translate avatar names into images

define('Avatar',['require','Utilities'],function (require) {
    'use strict';

    var // Require.js module dependencies
        Utilities = require('Utilities'),

        // Instance variables
        self,
        utilities,
        avatarDefault = 'avatar-default',
        avatarImages;

    // Constructor
    function Avatar () {
        // Preserve instance reference and enforce singleton
        if (typeof self === 'object') { return self; } else { self = this; }

        // Dependent Resources
        utilities = new Utilities();

        // List of supported Avatars
        avatarImages = {
            avatar1:  '../' + utilities.getImage('avatar1'),
            avatar2:  '../' + utilities.getImage('avatar2'),
            avatar3:  '../' + utilities.getImage('avatar3'),
            avatar4:  '../' + utilities.getImage('avatar4'),
            avatar5:  '../' + utilities.getImage('avatar5'),
            avatar6:  '../' + utilities.getImage('avatar6'),
            avatar7:  '../' + utilities.getImage('avatar7'),
            avatar8:  '../' + utilities.getImage('avatar8'),
            avatar9:  '../' + utilities.getImage('avatar9'),
            avatar10: '../' + utilities.getImage('avatar10'),
            avatar11: '../' + utilities.getImage('avatar11'),
            avatar12: '../' + utilities.getImage('avatar12'),
        };

        // Fetch the Facebook profile picture, or use the default
        this.getFacebookProfilePicture = function (facebookId, callback) {
            // Prepare the request
            var serverURI = 'https://graph.facebook.com/' + facebookId + '/picture';
            var queryString = '?redirect=false&height=256';
            var request = new XMLHttpRequest();

            // Setup the callback to send the picture URL
            if (callback) {
                request.onreadystatechange = function () {
                    if (request.readyState == 4) {
                        if (request.status == 200) {
                            var imgURL = utilities.getImage(this.getDefault());
                            var response = JSON.parse(request.responseText);
                            if (response && response.data && response.data.url) {
                                imgURL = response.data.url;
                            }
                            callback(imgURL);
                        } else {
                            callback(utilities.getImage(this.getDefault()));
                        }
                    }
                }.bind(this);
            }

            // Submit the request
            request.open('GET', serverURI + queryString, true);
            request.send();
        };
    };


    // Public Prototype Methods

    // Fetch the specified avatar image, facebook image, or use the default
    Avatar.prototype.getImage = function (avatarName, callback) {
        var avatarList = utilities.getObjectKeys(avatarImages);
        if (avatarList.indexOf(avatarName) >= 0) {
            // Avatar is in the stock list if pictures
            callback(avatarImages[avatarName]);
        } else if (avatarName == avatarDefault || avatarName == '' ||
                   typeof avatarName === 'undefined') {
            // Avatar has not been set, so use the default
            callback('../' + utilities.getImage(avatarDefault));
        } else {
            // Use the avatar name as a Facebook id to get profile picture
            this.getFacebookProfilePicture(avatarName, function (imgURL) {
                callback(imgURL);
            });
        }
    };


    // Return the map of valid avatar ids and image urls
    Avatar.prototype.getAvatarImages = function () {
        return avatarImages;
    };

    // Return the default avatar
    Avatar.prototype.getDefault = function () {
        return avatarDefault;
    };

    // Return Constructor
    return Avatar.prototype.constructor;
});

